import React, { Component } from 'react'
import './Style.scss'
import Helper from '../Helper';

export class TextOnly extends Component {

    render() {
        var content = this.props.blogSectionObj;
        var theme = this.props.theme;

        const titleStyle = {
            fontSize: theme.sectionTitleFontSize ? theme.sectionTitleFontSize : "",
            color: theme.sectionTitleFontColor ? theme.sectionTitleFontColor : "",
            justifyContent: theme.sectionTitleLayout ? theme.sectionTitleLayout : "",
            backgroundColor: theme.sectionTitleBackgroundColor ? theme.sectionTitleBackgroundColor : "",
            fontFamily: theme.sectionTitleFontFamily ? theme.sectionTitleFontFamily : "",
        }
        const bodyStyle = {
            fontSize: theme.sectionBodyFontSize ? theme.sectionBodyFontSize : "",
            color: theme.sectionBodyFontColor ? theme.sectionBodyFontColor : "",
            justifyContent: theme.sectionBodyLayout ? theme.sectionBodyLayout : "",
            backgroundColor: theme.sectionBodyBackgroundColor ? theme.sectionBodyBackgroundColor : "",
            fontFamily: theme.sectionBodyFontFamily ? theme.sectionBodyFontFamily : "",
        }
        return (

            <div className="col-md-12 col-sm-12 col-lg-12 col-12" data-type="TextOnly">
                    {content?.attributes?.title ?
                        <h3 className='card-text mt-3' style={titleStyle}  id={Helper.labelMerger(content.attributes.title)}>{content.attributes.title}</h3>
                        : ""}
                <div className='card-design'>

                    {content.body ?
                        <div className='card-body cms-green-btn article-html-content' style={bodyStyle} dangerouslySetInnerHTML={{ __html: content.body }}></div>
                        : ""}
                </div>
                {theme.horizontalRuler == 'true' ? <hr className='mx-5'></hr> : ""}
            </div>

        )
    }
}

export default TextOnly
